var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DragNDrop/dndType.ts";
export var DndType;

(function (DndType) {
  DndType["FROM_OWN_CLASSIFIER"] = "FROM_OWN_CLASSIFIER";
  DndType["FROM_DEPENDENCIES"] = "FROM_DEPENDENCIES";
})(DndType || (DndType = {}));